import * as CONFIGS from '@/statics/configs.js';
import axios from 'axios';

const SERVER_ACTIONS = {
  getLoginVerificationKey: function (store, mobileNumber) {
    store.commit('setMobileNumber', mobileNumber);
    var payload = {
      phone_number: mobileNumber
    };
    return axios.create().post('/user/request_otp/', payload, {
      baseURL: CONFIGS.baseURL,
      timeout: CONFIGS.apiTimeOut,
    });
  },
  getUserUuidFromGoogleToken: function (store, contex) {
    var payload = {
      token: contex.googleToken,
    };
    return axios.create().post('/user/google/login/ios/', payload, {
      baseURL: CONFIGS.baseURL,
      timeout: CONFIGS.apiTimeOut,
    });
  },
  checkUserGoogleLogin: function (store, contex) {
    var payload = {
      scope: contex.scope,
    };
    return axios.create().post('/user/google/validate/', payload, {
      baseURL: CONFIGS.baseURL,
      timeout: CONFIGS.apiTimeOut,
    });
  },
  checkLoginVerificationKey: function (store, confirmationCode) {
    var payload = {
      user_uuid: store.state.user.uuid,
      otp: confirmationCode,
    };
    return axios.create().post('/user/login/', payload, {
      baseURL: CONFIGS.baseURL,
      timeout: CONFIGS.apiTimeOut,
    });
  },
  getUserUuidFromMobile: function (store, mobileNumber) {
    var payload = {
      phone_number: mobileNumber,
    };
    return axios.create().post('/user/request_uuid/', payload, {
      baseURL: CONFIGS.baseURL,
      timeout: CONFIGS.apiTimeOut,
    });
  },
  getUserUuidFromGmail: function (store, gmailAddress) {
    var payload = {
      email: gmailAddress,
    };
    return axios.create().post('/user/request_uuid/', payload, {
      baseURL: CONFIGS.baseURL,
      timeout: CONFIGS.apiTimeOut,
    });
  },
  addSnapshot: function (store, contex) {
    var payload = {
      user_uuid: contex.userUUID,
      aux_auth_token: contex.token,
      hub_uuid: contex.hubUUID,
      content: contex.content,
      name: contex.name,
    }
    return axios.create().post('/user/snapshot/save/', payload, {
      baseURL: CONFIGS.baseURL,
      timeout: CONFIGS.apiTimeOut,
    });
  },
  getSnapshot: function (store, contex) {
    var payload = {
      user_uuid: contex.userUUID,
      aux_auth_token: contex.token,
      hub_uuid: contex.hubUUID
    }
    return axios.create().post('/user/snapshot/get_all/', payload, {
      baseURL: CONFIGS.baseURL,
      timeout: CONFIGS.apiTimeOut,
    });
  },
  grantSnapshotAccess: function (store, contex) {
    var payload = {
      user_uuid: contex.userUUID,
      aux_auth_token: contex.token,
      hub_uuid: contex.hubUUID,
      grantee_uuids_list: contex.uuids,
    }
    // payload = JSON.stringify(payload);
    return axios.create().post('/user/snapshot/grant_access/', payload, {
      baseURL: CONFIGS.baseURL,
      timeout: CONFIGS.apiTimeOut,
    });
    // return axios.create().post('/user/snapshot/grant_access/', '{"user_uuid":"' + contex.userUUID + '","aux_auth_token":"' + contex.token + '","hub_uuid":"' + contex.hubUUID + '","grantee_uuids_list":' + contex.uuids + '}', {
    //   baseURL: CONFIGS.baseURL,
    //   timeout: CONFIGS.apiTimeOut,
    // });
  },
  addAlexa: function (store, contex) {
    var payload = {
      user_uuid: contex.userUUID,
      aux_auth_token: contex.token,
      hubUuid: contex.hubUUID,
      hubPassword: contex.password,
    }
    return axios.create().post('/addHub/', payload, {
      baseURL: CONFIGS.alexaBaseURL,
      timeout: CONFIGS.apiTimeOut,
    });
  },
  addNest: function (store, contex) {
    var payload = {
      user_uuid: contex.userUUID,
      aux_auth_token: contex.token,
      hubUuid: contex.hubUUID,
      hubPassword: contex.password,
    }
    return axios.create().post('/addHub/', payload, {
      baseURL: CONFIGS.nestBaseURL,
      timeout: CONFIGS.apiTimeOut,
    });
  },
  addNotifications: function(store, context) {
    var payload = {
      user_uuid: context.userUuid,
      // aux_auth_token: context.token,
      hubUuid: context.hubUuid,
      notificationCode: context.notificationCode,
      action:context.action
    }
    return axios.create().post('/notifications/', payload, {
      baseURL: CONFIGS.baseURL,
      timeout: CONFIGS.apiTimeOut,
    });
  },
  deleteNotifications: function(store, context) {
    var payload = {
      user_uuid: context.userUuid,
      hubUuid: context.hubUuid,
      _id: context._id
    }
    let config = {
      method: 'delete',
      url: `${CONFIGS.baseURL}` + 'notifications/',
      data : payload,
      timeout: CONFIGS.apiTimeOut
    };
    return axios.request(config);
  },
  readNotifications: async function(store, context) {
    var payload = {
        user_uuid: context.userUuid,
        hubUuid: context.hubUuid,
      };
    // used put instead of get request because its not possible to send a get request with data body, and servers verification middlewares 
    // requires a data body which holds a user_id attribute inside it  
    return axios.create().put('/notifications/', payload, {
      baseURL: CONFIGS.baseURL,
      timeout: CONFIGS.apiTimeOut,
    });
  }
}
export default SERVER_ACTIONS;